import { render } from "./UpdateReleaseForm.vue?vue&type=template&id=2fcaaa9e"
import script from "./UpdateReleaseForm.vue?vue&type=script&lang=js"
export * from "./UpdateReleaseForm.vue?vue&type=script&lang=js"

import "./UpdateReleaseForm.vue?vue&type=style&index=0&id=2fcaaa9e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__